<template lang="pug">

  div.ZoomableImg

    div.ZoomableImg-container(v-for="(item, index) in src", :key="index" :class="{ 'ZoomableImg-container-sample': isSample }")
      img(:src="item.href", @click="clickHandler" @mouseenter="addCursor()" @mouseleave="removeCursor()" :class="(index === actualSlide) && 'active'" ref="thumb")

      div.ZoomableImg-icon(v-if="isThinBlade === true")
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 29" width="37" height="29"><g fill="#ffefce"><path d="M2.304688 1.839844v25.320312h32.390624V1.839844Zm27.175781 24.175781-5.660157-5.800781c.285157-.269532.554688-.558594.796876-.863282l6.511718 6.664063ZM18.5 21.195312c-3.726562 0-6.757812-3.105468-6.757812-6.921874 0-3.816407 3.03125-6.917969 6.757812-6.917969 3.726562 0 6.761719 3.101562 6.761719 6.917969 0 3.816406-3.035157 6.921874-6.761719 6.921874Zm15.078125 4.820313h-.867187l-7.441407-7.621094C25.972656 17.1875 26.375 15.78125 26.375 14.273438c0-4.445313-3.53125-8.0625-7.875-8.0625s-7.875 3.617187-7.875 8.0625c0 4.449218 3.53125 8.066406 7.875 8.066406 1.648438 0 3.171875-.519532 4.441406-1.40625l4.960938 5.082031H3.421875V2.984375h30.15625Zm0 0"/><path d="M13.132812 14.273438H14.25c0-2.398438 1.90625-4.351563 4.25-4.351563V8.777344c-2.960938 0-5.367188 2.46875-5.367188 5.496094Zm0 0"/></g></svg>
        p {{ $t('icon.thin_blade') }}

    div.Zoomable_cursor(ref="cursor")
      span
      span

</template>

<script>

import store from '@/store'

export default {
  props: {
    src: {
      type: Array,
      required: true
    },
    actualSlide: {
      type: Number,
      default: 0
    },
    isThinBlade: {
      type: Boolean,
      default: false
    },
    isSample: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      timeOut: null,
      open: false
    }
  },
  mounted () {
    this.$emit('getref', this.$refs.thumb[this.actualSlide])
    window.addEventListener('mousemove', this.captureCursor)
  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.captureCursor)
  },
  methods: {
    addCursor () {
      if (!!('ontouchstart' in window) || !!('onmsgesturechange' in window)) return
      this.open = false
      clearTimeout(this.timeOut)
      this.$refs.cursor.classList.add('Zoomable_cursor_is-visible')
      document.body.style.cursor = 'none'
    },
    removeCursor () {
      if (this.$refs.cursor) { this.$refs.cursor.classList.remove('Zoomable_cursor_is-visible') }

      if (this.open) return

      this.timeOut = setTimeout(() => {
        document.body.style.cursor = null
      }, 50)
    },
    captureCursor (e) {
      let x = e.clientX - 30
      let y = e.clientY - 30

      this.$refs.cursor.style.left = x + 'px'
      this.$refs.cursor.style.top = y + 'px'
    },
    /**
     * Au clic sur l'image
     */
    clickHandler (e) {
      e.preventDefault()

      this.removeCursor()

      setTimeout(() => {
        this.open = true
        // On dispatch les options permettant d'ouvrir la visionneuse fullscreen
        store.dispatch('setFullscreenImgOptions', {
          src: this.src[this.actualSlide],
          thumbEl: this.$refs.thumb[this.actualSlide]
        })
      }, 150)
    }
  }
}
</script>

<style lang="stylus">
  .is-disabled

    .ZoomableImg

      opacity 0.5

  .ZoomableImg
    // cursor url('/img/ui/cursor-zoom-in.svg') 32 32, zoom-in
    transition opacity 1s $ease

    &-container
      margin 0 auto
      display block

    &-container-sample
      position absolute
      height 100%
      width 100%

    &-icon
      position absolute
      top calc(100% + 24px)
      right 50%
      z-index 1
      display flex
      align-items center
      transform translateX(50%)

      p
        color $beige
        margin-left 10px

    img

      height 100%
      width auto
      position: absolute
      z-index: 1
      top: 0
      left: 0
      opacity: 0
      left: 50%
      transform: translateX(-50%)
      transition opacity 1s $ease
      display: block
      margin 0px auto
      cursor none!important

      @media $mq_landscape
        width auto
        height 100%

      @media $mq_portrait
        object-fit: contain;
        width: 100%;
        height: 100%;

      &:first-child
       position: relative
       left: inherit
       transform: none

      &.active

       opacity: 1
       z-index: 2

  .Zoomable_cursor

    position fixed
    pointer-events none
    z-index: 20
    top 0px
    left 0px
    height 60px
    border-radius 50%
    border 1px solid transparent
    box-sizing border-box
    width 60px
    overflow hidden
    opacity 0
    transform scale(0.3)
    transition transform 0.4s $ease, opacity 0.2s 0.2s $ease
    background-color rgba(0,0,0,0.5)

    span

      width 2px
      background-color $beige
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      height 0%
      transition all 0.6s 0.2s $ease

      &:last-child

        transform translate(-50%, -50%) rotate(90deg)

    &_is-visible

      transform scale(1)
      opacity 1
      transition transform 0.6s $ease, opacity 0.6s 0s $ease
      border-color $beige

      span

        height 45%

</style>
